<template>
  <v-data-iterator
    ref="datatableObj"
    v-drag-and-drop:options="
      myself.optionsDrag != null
        ? myself.optionsDrag
        : { dropzoneSelector: 'null', draggableSelector: 'null' }
    "
    :hide-actions="!myself.configprops.paginacao"
    v-show="myself.loading == false"
    v-model="myself.selected"
    :headers="myself.headers"
    :items="myself.resultset"
    :pagination.sync="myself.paginationActive"
    :total-items="myself.totalItems"
    :rows-per-page-items="
      n == 1
        ? [
            myself.lista.modulo.mod_paginacao
              ? myself.lista.modulo.mod_paginacao * 1
              : 20,
            { text: T('Exibir todos'), value: -1 }
          ]
        : ['']
    "
    :rows-per-page-text="T('Registros por página')"
    :loading="myself.loadingIntra"
    item-key="id"
    class="data-table-default"
    content-tag="v-layout"
    row
    wrap
  >
    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

    <template v-slot:item="props">
      <v-flex sm12 :active="props.selected" :trid="props.item['id']">
        <v-card class="ma-1">
          <div
            class="noexport"
            v-if="myself.configprops.select && myself.lista.modulo.mod_numero"
            @click="props.selected = !props.selected"
          >
            <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
          </div>

          <div v-for="coluna in myself.headers" :key="coluna.text" class="text-xs-left">
            <div style="border-bottom:solid #eee 1px;" class="pa-1">
              <span class="caption" style="display: table-cell;">{{ coluna.text }}:&nbsp;</span>
              <span class="font-weight-bold" style="display: table-cell;">
                <crudcampo
                  v-if="props.item[coluna.value]"
                  :crud="myself"
                  v-model="props.item[coluna.value]"
                  :campo="coluna.campo"
                  :row="props.item"
                ></crudcampo>
                <span style="display: table-cell;" v-else>---</span>
              </span>
            </div>
          </div>
          <div class="text-xs-center center-content-flex" v-if="myself.configprops.acoes">
            <div class="data-table-list-icon">
              <template v-if="myself.configcruds[myself.module].idiomas == null">
                <v-icon
                  :title="T('Editar')"
                  v-if="myself.avaliaPermissao('edit', props.item)"
                  class="data-table-icon-action"
                  @click="myself.editItem(props.item)"
                >edit</v-icon>
              </template>

              <template v-else>
                <v-btn
                  :title="T('Editar')"
                  v-for="(z, index) of myself.configcruds[myself.module]
                    .idiomas"
                  :key="'edit_of_' + index"
                  v-if="myself.avaliaPermissao('edit', props.item)"
                  class="data-table-icon-action"
                  @click="myself.editItem(props.item, z)"
                >{{ z }}</v-btn>
              </template>
              <!--
                        <v-icon
                          v-if="myself.avaliaPermissao('add',props.item) && myself.avaliaPermissao('edit',props.item)"
                          class="data-table-icon-action"
                          @click="myself.cloneItem(props.item)"
                        >file_copy</v-icon>
              -->

              <v-icon
                :title="T('Visualizar')"
                v-if="myself.avaliaPermissao('view', props.item)"
                class="data-table-icon-action"
                @click="myself.viewItem(props.item)"
              >remove_red_eye</v-icon>

              <v-icon
                :title="T('Excluir')"
                v-if="myself.avaliaPermissao('del', props.item)"
                class="data-table-icon-action"
                @click="
                  props.item.__deleting = true /*myself.deleteItem(props.item)*/
                "
              >delete</v-icon>
            </div>

            <div class="dialog-default excluirItemTable">
              <v-dialog v-model="props.item.__deleting" width="400">
                <v-card>
                  <div class="dialog-title-default">
                    <p>{{T("Excluir item")}}</p>

                    <h3>{{T("Deseja realmente excluir o item selecionado?")}}</h3>
                  </div>

                  <div class="dialog-footer-default">
                    <v-card-actions class="dialog-footer-btns">
                      <v-btn color="grey" flat @click="props.item.__deleting = false">{{T('Não')}}</v-btn>

                      <v-btn
                        color="primary"
                        @click="
                          props.item.__deleting = false;
                          myself.deleteItem(props.item);
                        "
                      >{{T("Sim")}}</v-btn>
                    </v-card-actions>
                  </div>
                </v-card>
              </v-dialog>
            </div>

            <span
              v-for="(custom, indc) in myself.lista.custom"
              :key="'cs_' + indc"
              @click="
                myself
                  .evaluatedCustom(custom, props.item.id, props.item)
                  .action(props.item.id, props.item)
              "
            >
              <template
                v-if="
                  custom.cus_massa == false &&
                    myself.avaliaPermissao('cs' + custom.cus_pk, props.item)
                "
              >
                <span
                  v-if="
                    myself.evaluatedCustom(custom, props.item.id, props.item)
                      .html
                  "
                  v-html="
                    myself.evaluatedCustom(custom, props.item.id, props.item)
                      .html
                  "
                ></span>
                <v-btn
                  small
                  v-else-if="
                    myself.evaluatedCustom(custom, props.item.id, props.item)
                      .name
                  "
                >
                  {{
                  myself.evaluatedCustom(custom, props.item.id, props.item)
                  .name
                  }}
                </v-btn>
              </template>
            </span>

            <span
              v-if="props.item._flow"
              v-for="(status, indc) in props.item._flow"
              :key="'flow_' + indc"
            >
              <template v-if="myself.avaliaPermissao('flow_' + status.act)">
                <v-btn
                  dark
                  @click="myself.flowItem(props.item)"
                  color="orange"
                  small
                >{{ T(status.name) }}</v-btn>
              </template>
            </span>

            <span
              v-if="props.item._flowaction"
              v-for="(action, indc) in props.item._flowaction"
              :key="'flowaction_' + indc"
            >
              <template v-if="myself.avaliaPermissao('flowact_' + action.act)">
                <v-btn
                  dark
                  color="green"
                  @click="myself.callFlowAction(action.act, props.item.id)"
                  small
                >{{ T(action.name) }}</v-btn>
              </template>
            </span>
            &nbsp;&nbsp;&nbsp;
          </div>
        </v-card>
      </v-flex>
    </template>

    <template
      slot="pageText"
      slot-scope="props"
    >{{T("Exibindo %0 até %1 de %2", [props.pageStart, props.pageStop, props.itemsLength])}}</template>
    <template slot="footer">
      <div v-if="myself.configprops.rodape" colspan="100%" class="text-xs-left">
        <span
          v-for="(custom, indc) in myself.lista.custom"
          :key="indc"
          @click="
            myself
              .evaluatedCustom(custom, myself.selected, null)
              .action(myself.selected, null)
          "
        >
          <template
            v-if="
              custom.cus_massa == true &&
                myself.avaliaPermissao('cs' + custom.cus_pk, null)
            "
          >
            <span
              v-if="myself.evaluatedCustom(custom, myself.selected, null).html"
              v-html="
                myself.evaluatedCustom(custom, myself.selected, null).html
              "
            ></span>
            <v-btn small v-else>
              {{
              myself.evaluatedCustom(custom, myself.selected, null).name
              }}
            </v-btn>
          </template>
        </span>

        <div v-if="myself.metadata.rodape">
          <v-layout row>
            <v-flex xs4 v-for="(roda, rk) in myself.lista.modulo.rodape" :key="rk">
              <strong>{{ T(roda.nome) }}:</strong>

              <crudcampo
                :crud="myself"
                v-model="myself.metadata.rodape['rodape_col_' + rk]"
                modo="view"
                :campo="{
                  cmp_coluna: 'rodape_col_' + rk,

                  cmp_tipo:
                    roda.componente || '' != '' ? roda.componente : 'text',
                  componente: roda.componente,
                  param: roda.componente_param,
                  cmp_conta: roda.conta,
                  cmp_titulo: T(roda.nome),
                  cmp_view: true
                }"
                :row="myself.metadata.rodape"
              ></crudcampo>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </template>
    <template slot="no-data">
      <template>
        <v-alert
          :value="true"
          color="white black--text"
          icon="warning"
          v-if="myself.loading == false"
          transition="scale-transition"
        >{{T('Nenhum registro encontrado.')}}</v-alert>
        <div v-if="myself.loading == true">&nbsp;</div>
      </template>
    </template>
  </v-data-iterator>
</template>

<script>
try{
  var _baseComponent = require("@/admin/tpl/tabelado.vue").default;
}catch(err){
  var _baseComponent = require("@/framework/admin/tpl/tabelado.vue").default;
}

const crudcampo = global.reqClass.requirecmpmix("@/admin/listagem/crudcampo");

export default {
  extends: _baseComponent,
  components: { crudcampo },
  props: ["n", "myself"],
  data() {
    return {};
  },
};
</script>
